<script>
  let active = {};
  let customlink = `/custom?strategy=%7B"positions":%5B%5D,"hlperiod":"intraday","squareoff":"oneleg"%7D`;

  $: setActive();

  function setActive() {
    if (window.location.pathname === "/custom") {
      active = {};
      active.custom = "active";
    } else if (window.location.pathname === "/reports") {
      active = {};
      active.reports = "active";
    }
  }

  function toCustom() {
    active = {};
    active.custom = "active";
  }
  function toReports() {
    active = {};
    active.reports = "active";
  }
</script>

<div class="navbar-expand-md">
  <div class="collapse navbar-collapse" id="navbar-menu">
    <div class="navbar navbar-light">
      <div class="container-fluid">
        <ul class="navbar-nav">
          <li class="nav-item {active.custom}" on:click={toCustom}>
            <a class="nav-link" href={customlink}>
              <span class="nav-link-icon d-md-none d-lg-inline-block"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-tool"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
                  />
                </svg>
              </span>
              <span class="nav-link-title"> Custom </span>
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="./docs/index.html">
              <span class="nav-link-icon d-md-none d-lg-inline-block"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-gift"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <rect x="3" y="8" width="18" height="4" rx="1" />
                  <line x1="12" y1="8" x2="12" y2="21" />
                  <path d="M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7" />
                  <path
                    d="M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
                  />
                </svg>
              </span>
              <span class="nav-link-title"> Ready-Made </span>
            </a>
          </li>

          <li class="nav-item {active.reports}" on:click={toReports}>
            <a class="nav-link" href="/reports">
              <span class="nav-link-icon d-md-none d-lg-inline-block"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-presentation-analytics"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 12v-4" />
                  <path d="M15 12v-2" />
                  <path d="M12 12v-1" />
                  <path d="M3 4h18" />
                  <path d="M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10" />
                  <path d="M12 16v4" />
                  <path d="M9 20h6" />
                </svg>
              </span>
              <span class="nav-link-title"> Reports </span>
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="./docs/index.html">
              <span class="nav-link-icon d-md-none d-lg-inline-block"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-history"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <polyline points="12 8 12 12 14 14" />
                  <path d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" />
                </svg>
              </span>
              <span class="nav-link-title"> History </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
